import { QueryHookOptions, useQuery } from '@apollo/client';
import { AccessLevel } from 'redux/authentication/enums';

import { USER_BY_ROLE_QUERY_FOR_TEACHER_BY_UNIT_SLUG } from './queries';
import { User } from './types';

export const useUsersByRoleForTeacherByUnitSlug = (role: AccessLevel, options?: QueryHookOptions) =>
  useQuery<{ users: User[] }>(USER_BY_ROLE_QUERY_FOR_TEACHER_BY_UNIT_SLUG, { ...options, variables: { role } });
